import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import {
  ButtonGroup,
  Button,
  Dialog,
  DialogInner,
  DialogHeader,
  DialogContent,
} from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { ISiteConfiguration } from "./Types";
import Edit from "~icons/ic/outline-edit";
import "./Style.scss";

interface ISiteViewDialogProps {
  site: ISiteConfiguration;
  onCloseDialog: () => void;
  onEditClick: (site: ISiteConfiguration) => void;
  onRemoveClick: (site: ISiteConfiguration) => void;
}

/**
 * Responsible to render scheduling popup
 */
export const SiteViewDialog: React.FC<ISiteViewDialogProps> = ({ site, onEditClick,
  onRemoveClick, onCloseDialog }) => {
  const { t: translate } = useTranslation();
  return (
    <div id="site-view-dialog">
      <Dialog
        open={true}
        onOpenChange={onCloseDialog}
        preventBackdropClose={true}
      >
        <DialogInner style={{ maxWidth: "25%", width: "25%" }}>
          <DialogHeader>
            {translate("MultiSiteList.SiteDialog.Title")}
          </DialogHeader>
          <DialogContent>
            <div className="site-view-container">
              <div className="site-view-container__label">
                <p><strong>{translate("MultiSiteList.SiteDialog.Name.Title")}</strong></p>
              </div>
              <div className="site-view-container__content">
                <p>{site.name}</p>
              </div>
            </div>
            <div className="site-view-container">
              <div className="site-view-container__label">
                <p><strong>{translate("MultiSiteList.SiteDialog.Postcode.Title")}</strong></p>
              </div>
              <div className="site-view-container__content">
                <p>{site.postcode}</p>
              </div>
            </div>
            <div className="site-view-container">
              <div className="site-view-container__label">
                <p><strong>{translate("MultiSiteList.SiteDialog.Radius.Title")}</strong></p>
              </div>
              <div className="site-view-container__content">
                <p>{site.radius} {translate("MultiSiteList.SiteDialog.Miles")}</p>
              </div>
            </div>
            <ButtonGroup className="site-view-container__buttons">
              <Button
                variant={ButtonVariantType.FILLED}
                onClick={(): void => onEditClick(site)}>
                <Edit title="edit"/>
                {translate("Button.Edit")}
              </Button>
              <Button
                borderless={true}
                onClick={(): void => onRemoveClick(site)}>
                {translate("Button.RemoveSite")}
              </Button>
            </ButtonGroup>
          </DialogContent>
        </DialogInner>
      </Dialog>
    </div>
  );
};
